var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngleup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FontAwsome_angle-down_",
    "data-name": "FontAwsome (angle-down)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.032,
    height: 11,
    viewBox: "0 0 17.032 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_angle-down_2",
    "data-name": "FontAwsome (angle-down)",
    d: "M7.566,153.125.325,160.366a1.273,1.273,0,0,0,0,1.8l1.2,1.2a1.273,1.273,0,0,0,1.8,0l5.133-5.133,5.133,5.133a1.273,1.273,0,0,0,1.8,0l1.2-1.2a1.273,1.273,0,0,0,0-1.8l-7.241-7.241a1.266,1.266,0,0,0-1.8,0Z",
    transform: "translate(0.05 -152.75)",
    fill: "#0466c8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleup);
export default __webpack_public_path__ + "static/media/angleup.2c5d7cb7.svg";
export { ForwardRef as ReactComponent };